import React from 'react';

import './index.scss';


type InputTextProps = {};

const InputText = ({ }: InputTextProps): JSX.Element => {
  return (
    <div className="input-text-container">
      {/* <input></input> */}
    </div>
  );
};

export default InputText;